/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";
import {
  NavLink,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { Helmet } from "react-helmet-async";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import qs from "qs";
import SearchIcon from "@mui/icons-material/Search";
import RestoreIcon from '@mui/icons-material/Restore';
import swal from "sweetalert";
import DeleteIcon from "@mui/icons-material/Delete";

import {
  Alert,
  Breadcrumbs as MuiBreadcrumbs,
  Button,
  Chip as MuiChip,
  Divider as MuiDivider,
  Grid,
  IconButton,
  Link,
  Paper as MuiPaper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { green, orange, red } from "@mui/material/colors";
import { Add as AddIcon, Download } from "@mui/icons-material";
import { spacing } from "@mui/system";
import { makeStyles, withStyles } from "@mui/styles";
import axios from "../../CustomAxios";
import Loading from "../components/Loading";
import { connect } from "react-redux";
import CustomerCompanyFilter from "./CustomerCompanyFilter";
import { CSVLink } from "react-csv";
import moment from "moment";

const Divider = styled(MuiDivider)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

const useStyles = makeStyles({
  tableCell: {
    padding: "0px 12px 0px 0px",
    width: "1000px",
  },
});

const StyledTableContainer = withStyles((theme) => ({
  root: {
    // width: "max-content",
  },
}))(TableContainer);

const Chip = styled(MuiChip)`
  ${spacing};
  background: ${(props) => props.shipped && green[500]};
  background: ${(props) => props.processing && orange[700]};
  background: ${(props) => props.cancelled && red[500]};
  color: ${(props) => props.theme.palette.common.white};
`;

const Spacer = styled.div`
  flex: 1 1 100%;
`;

const ToolbarTitle = styled.div`
  min-width: 150px;
`;

function createData(
  id,
  name,
  email,
  mobile,
  address_line_one,
  address_line_two,
  pincode,
  state,
  city,
  address,
  is_deleted
) {
  return {
    id,
    name,
    email,
    mobile,
    address_line_one,
    address_line_two,
    pincode,
    state,
    city,
    address,
    is_deleted,
  };
}

const headCells = [
  { key: "name", alignment: "left", label: "Company Name" },
  { key: "email", alignment: "left", label: "Email" },
  { key: "mobile", alignment: "left", label: "Phone Number" },
  { key: "address", alignment: "left", label: "Address" },
];
const rows = [];

const getCompanies = async (
  authData,
  setLoader,
  setRows,
  search,
  sortingField,
  sortingOrder,
  page,
  limit,
  setTotal,
  includeDeleted
) => {
  try {
    setLoader(true);
    const config = {
      headers: {
        Authorization: "Bearer " + authData.access_token,
      },
    };
    const { data } = await axios.get(
      `/api/v1/${authData?.type
      }/customer_company?sorting_field=${sortingField}&sorting_order=${sortingOrder}&search_keyword=${search}&page=${page + 1
      }&limit=${limit}&include_deleted=${includeDeleted ? "YES" : "NO"}`,
      config
    );
    if (data.success) {
      const companies = data.data.data;
      setTotal(data.data.metadata.total_results);

      let rows = [];
      companies.map((company) => {
        let defAddress = company.addresses[company.default_address];

        rows.push(
          createData(
            company._id,
            company.name,
            company.email_address,
            company.phone_number,
            defAddress.address_line_one,
            defAddress.address_line_two,
            defAddress.pincode,
            defAddress.state,
            defAddress.city,
            defAddress.address_line_one +
            ", " +
            defAddress.address_line_two +
            ", " +
            defAddress.city +
            "," +
            defAddress.state +
            ", " +
            defAddress.pincode +
            ", " +
            "India",
            company.is_deleted
          )
        );
      });
      setRows(rows);
      setLoader(false);
    }
  } catch (error) {
    console.log(error);
    setLoader(false);
  }
};

const EnhancedTableHead = (props) => {
  const { viewPermission, editPermission, auths, authData } = props;
  const [head, setHeads] = useState(headCells);
  useEffect(() => {
    if (viewPermission) {
      setHeads((prev) => [
        ...prev,
        { id: "view", alignment: "center", label: "View" },
      ]);
    }
    if (editPermission) {
      setHeads((prev) => [
        ...prev,
        { id: "edit", alignment: "center", label: "Edit" },
      ]);
    }
    if (auths?.user?.role?.permissions.includes("delete_customer_company") || authData?.type === "super_admin") {
      setHeads((prev) => [
        ...prev,
        { id: "delete", alignment: "center", label: "Action" },
      ]);
    }
  }, [viewPermission, editPermission]);
  return (
    <TableHead>
      <TableRow>
        {head.map((headCell) => (
          <TableCell
            // style={{ width: 100 }}
            key={headCell.id}
            align={headCell.alignment}
            padding={headCell.disablePadding ? "none" : "normal"}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

const EnhancedTableToolbar = (props) => {
  // Here was 'let'
  const {
    sortingField,
    sortingOrder,
    setSortingField,
    setSortingOrder,
    search,
    setSearch,
    setFilter,
    rows,
    setOnSearch,
    csvPermission,
    includeDeleted,
    setIncludeDeleted,
  } = props;
  const navigate = useNavigate();

  let timestamp = moment().format("DD-MM-YY HH:mm");

  const csvReport = {
    filename: `Customer_Companies_${timestamp}.csv`,
    headers: headCells,
    data: rows,
  };
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        setOnSearch(true);
      }}
    >
      <Toolbar>
        <ToolbarTitle>
          <Typography variant="h6" id="tableTitle">
            Companies
          </Typography>
        </ToolbarTitle>
        <Spacer />

        {csvPermission && (
          <CSVLink
            style={{ color: "green", textDecoration: "none" }}
            {...csvReport}
          >
            <Button
              variant="outlined"
              sx={{ ml: 2, mr: 2 }}
              endIcon={<Download />}
            >
              CSV
            </Button>
          </CSVLink>
        )}
        <TextField
          value={search}
          size="small"
          style={{ width: "100%", marginRight: 10 }}
          label="Search"
          placeholder="Name/ Email/ Phone Number"
          onChange={(e) => setSearch(e.target.value)}
        />

        <Button
          endIcon={<SearchIcon />}
          style={{ width: "20%" }}
          variant="contained"
          type="submit"
        >
          Search
        </Button>
        <div>
          <CustomerCompanyFilter
            setFilter={setFilter}
            sortingField={sortingField}
            sortingOrder={sortingOrder}
            setSortingField={setSortingField}
            setSortingOrder={setSortingOrder}
            includeDeleted={includeDeleted}
            setIncludeDeleted={setIncludeDeleted}
            show={false}
          />
        </div>
        <Tooltip title="Register Company">
          <IconButton>
            <AddIcon
              onClick={() =>
                navigate(
                  "/dashboard/company/customer-companies/create-customer-company"
                )
              }
            />
          </IconButton>
        </Tooltip>
      </Toolbar>
    </form>
  );
};

function EnhancedTable({
  sortingField,
  sortingOrder,
  setSortingField,
  setSortingOrder,
  setFilter,
  search,
  setSearch,
  rows,
  viewPermission,
  editPermission,
  setOnSearch,
  page,
  handleChangePage,
  handleChangeRowsPerPage,
  rowsPerPage,
  total_results,
  csvPermission,
  includeDeleted,
  setIncludeDeleted,
  auths,
  authData,
  setLoader
}) {
  const navigate = useNavigate();
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("customer");
  const [selected, setSelected] = React.useState([]);

  const location = useLocation();
  const [message, setMessage] = useState(location?.state?.message);
  const snackRef = useRef(null);
  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const handleCompanyOperations = async (id) => {
    try {
      setLoader(true);
      const response = await axios.delete(
        `/api/v1/${authData?.type}/customer_company/${id}/delete`,
        {
          headers: {
            Authorization: "Bearer " + authData.access_token,
          },
        }
      );
      if (response.status === 200) {
        setMessage(response?.data?.message || "Company operation successful");
        setState({ ...state, open: true });
        setLoader(false);
        setFilter(true);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  useEffect(() => {
    if (location?.state?.success) {
      snackRef.current.click();
      navigate(location.pathname, { replace: true });
    }
  }, [location?.state]);

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  return (
    <div>
      <Button
        ref={snackRef}
        style={{ display: "none" }}
        onClick={handleClick({ vertical: "top", horizontal: "center" })}
      >
        Click
      </Button>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        onClose={handleClose}
        key={vertical + horizontal}
      >
        <Alert mt={2} mb={4} severity="success">
          {message}
        </Alert>
      </Snackbar>
      <Paper>
        <EnhancedTableToolbar
          setOnSearch={setOnSearch}
          setFilter={setFilter}
          sortingField={sortingField}
          sortingOrder={sortingOrder}
          setSortingField={setSortingField}
          setSortingOrder={setSortingOrder}
          search={search}
          setSearch={setSearch}
          numSelected={selected.length}
          rows={rows}
          csvPermission={csvPermission}
          includeDeleted={includeDeleted}
          setIncludeDeleted={setIncludeDeleted}
          auths={auths}
          authData={authData}
        />
        <StyledTableContainer>
          <Table size={"small"}>
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              rowCount={rows.length}
              viewPermission={viewPermission}
              editPermission={editPermission}
              auths={auths}
              authData={authData}
            />
            <TableBody>
              {rows.map((row, index) => {
                return (
                  <TableRow
                    role="checkbox"
                    tabIndex={-1}
                    key={`${row.id}-${index}`}
                    style={{
                      backgroundColor: row?.data?.is_deleted ? "#eeaa9c" : "#fff",
                    }}
                  >
                    <TableCell align="left">{row.name}</TableCell>
                    <TableCell align="left">{row.email}</TableCell>
                    <TableCell align="left">{row.mobile}</TableCell>
                    <TableCell align="left">
                      {row.address_line_one}, {row.address_line_two}, {row.city}
                      , {row.state}, {row.pincode}, India{" "}
                    </TableCell>
                    {viewPermission ? (
                      <TableCell align="center">
                        <VisibilityIcon
                          style={{ cursor: "pointer", color: "green" }}
                          onClick={() =>
                            navigate(
                              `/dashboard/company/customer-companies/${row.id}`,
                              {
                                state: {
                                  id: row.id,
                                },
                              }
                            )
                          }
                        />
                      </TableCell>
                    ) : null}
                    {editPermission ? (
                      <TableCell align="center">
                        <EditIcon
                          style={{ cursor: "pointer", color: "red" }}
                          onClick={() =>
                            navigate(
                              `/dashboard/company/customer-companies/update-customer-company/${row.id}`,
                              {
                                state: { id: row.id },
                              }
                            )
                          }
                        />
                      </TableCell>
                    ) : null}
                    {(authData.type === "super_admin" || auths?.user?.role?.permissions.includes("delete_customer_company")) ? (
                      row.is_deleted ? (<TableCell align="center">
                        <Tooltip title="Restore Company">
                        <RestoreIcon
                          style={{ cursor: "pointer", color: "green" }}
                          onClick={() => {
                            swal({
                              title: "Are you sure?",
                              text: "You want to recover this company",
                              icon: "warning",
                              buttons: ["Cancel", "Yes"],
                              dangerMode: true,
                            }).then((willDelete) => {
                              if (willDelete) {
                                handleCompanyOperations(row.id);
                              }
                            })
                          }
                          }
                        />
                        </Tooltip>

                      </TableCell>) : (<TableCell align="center">
                        <Tooltip title="Delete Company">
                        <DeleteIcon
                          style={{ cursor: "pointer", color: "red" }}
                          onClick={() => {
                            swal({
                              title: "Are you sure?",
                              text: "You want to delete this company",
                              icon: "warning",
                              buttons: ["Cancel", "Yes"],
                              dangerMode: true,
                            }).then((willDelete) => {
                              if (willDelete) {
                                handleCompanyOperations(row.id);
                              }
                            })
                          }
                          }
                        />
                        </Tooltip>
                      </TableCell>)
                    ) : null}
                  </TableRow>
                );
              })}
              {/* {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={8} />
                </TableRow>
              )} */}
            </TableBody>
          </Table>
        </StyledTableContainer>
        <TablePagination
          rowsPerPageOptions={[50, 100, 250]}
          component="div"
          count={total_results}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}

function CustomerCompanies({ auths }) {
  const authData = JSON.parse(localStorage.getItem("AuthData"));
  const token = JSON.parse(localStorage.getItem("AuthData"));
  const [loader, setLoader] = useState(true);
  const [rows, setRows] = useState([]);
  const [viewPermission, setViewPermission] = useState(false);
  const [editPermission, setEditPermission] = useState(false);
  const [csvPermission, setCsvPermission] = useState(false);

  const [sortingField, setSortingField] = useState("updated_at");
  const [sortingOrder, setSortingOrder] = useState("desc");

  const [searchParams] = useSearchParams();

  const [search, setSearch] = useState(
    searchParams.get("search_keyword") || ""
  );
  const navigate = useNavigate();
  const location = useLocation();
  const [filter, setFilter] = useState(true);

  const [page, setPage] = React.useState(
    searchParams.get("page") ? Number(searchParams.get("page")) : 0
  );
  const [rowsPerPage, setRowsPerPage] = React.useState(
    searchParams.get("limit") ? Number(searchParams.get("limit")) : 50
  );
  const [includeDeleted, setIncludeDeleted] = React.useState(
    searchParams.get("include_deleted") ? searchParams.get("include_deleted") === "YES" ? true : false : false
  );
  const [total, setTotal] = useState(0);
  const [onSearch, setOnSearch] = useState(false);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    let sorting_order = sortingOrder;
    let sorting_field = sortingField;
    let sk = search || "";
    if (filter || onSearch || includeDeleted) {
      let sf = "";
      if (sorting_field) {
        sf = sorting_field;
      } else {
        sf = sortingField;
      }
      let so = "";
      if (sorting_order) {
        so = sorting_order;
      } else {
        so = sortingOrder;
      }

      navigate(
        `/dashboard/company/customer-companies?sorting_field=${sf}&sorting_order=${so}&search_keyword=${sk}&page=${page}&limit=${rowsPerPage}&include_deleted=${includeDeleted ? "YES" : "NO"}`,
        { replace: true }
      );
      getCompanies(
        token,
        setLoader,
        setRows,
        sk,
        sf,
        so,
        page,
        rowsPerPage,
        setTotal,
        includeDeleted
      );
      setFilter(false);
      setOnSearch(false);
    } else {
      navigate(
        `/dashboard/company/customer-companies?sorting_field=${sortingField}&sorting_order=${sortingOrder}&search_keyword=${search}&page=${page}&limit=${rowsPerPage}&include_deleted=${includeDeleted ? "YES" : "NO"}`,
        { replace: true }
      );
      getCompanies(
        token,
        setLoader,
        setRows,
        search,
        sortingField,
        sortingOrder,
        page,
        rowsPerPage,
        setTotal,
        includeDeleted,
        auths,
        setLoader
      );
      setFilter(false);
      setOnSearch(false);
    }
  }, [filter, page, rowsPerPage, onSearch]);

  useEffect(() => {
    if (
      auths?.user?.role?.permissions.includes(
        "view_customer_company_profile"
      ) ||
      authData?.type === "super_admin"
    ) {
      setViewPermission(true);
    }
    if (
      ["view_customer_company_profile", "update_customer_company"].every((k) =>
        auths?.user?.role?.permissions.includes(k)
      ) ||
      authData?.type === "super_admin"
    ) {
      setEditPermission(true);
    }
    if (
      auths?.user?.role?.permissions.includes("download_csv") ||
      authData?.type === "super_admin"
    ) {
      setCsvPermission(true);
    }
  }, [auths.user]);

  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              CUSTOMER COMPANIES
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Typography>Customer Companies</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            <EnhancedTable
              setOnSearch={setOnSearch}
              setFilter={setFilter}
              viewPermission={viewPermission}
              editPermission={editPermission}
              rows={rows}
              sortingField={sortingField}
              sortingOrder={sortingOrder}
              setSortingField={setSortingField}
              setSortingOrder={setSortingOrder}
              search={search}
              setSearch={setSearch}
              page={page}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              rowsPerPage={rowsPerPage}
              total_results={total}
              csvPermission={csvPermission}
              includeDeleted={includeDeleted}
              setIncludeDeleted={setIncludeDeleted}
              auths={auths}
              authData={authData}
              setLoader={setLoader}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});
export default connect(mapStateToProps, null)(CustomerCompanies);
